// extracted by mini-css-extract-plugin
export default {"background":"TF","weightImage":"UF","drinkImage":"VF","content":"WF","rtbLeft":"XF","rtbRight":"YF","rtbLeftMobile":"ZF","imageContainer":"aG","rtbBox":"bG","line":"cG","rtbDesktop":"eG"};
    if(module.hot) {
      // 1713912566071
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  